/* CCC Courier theme v1.3.0 — shared scripts */
(function () {
  'use strict';

  var CCC = (window.CCC = window.CCC || {});
  var settings = CCC.settings || {};

  /* ---------- Money ---------- */
  CCC.formatMoney = function (cents) {
    var format = CCC.moneyFormat || '£{{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(num, decimals, thousands, dec) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default:
          return value % 1 === 0 ? withDelimiters(value, 0, ',', '.') : withDelimiters(value, 2, ',', '.');
      }
    });
  };

  /* ---------- UK postcodes ---------- */
  var SCOTLAND = ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'TD', 'ZE'];
  var ISLANDS = ['IM', 'JE', 'GY'];
  var POSTCODE_RE = /^([A-Z]{1,2}[0-9][A-Z0-9]?)\s*([0-9][A-Z]{2})$/;

  CCC.postcode = {
    clean: function (value) {
      return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    },
    format: function (value) {
      var c = this.clean(value);
      if (c.length < 5) return String(value || '').toUpperCase().trim();
      return c.slice(0, -3) + ' ' + c.slice(-3);
    },
    isValid: function (value) {
      return POSTCODE_RE.test(this.format(value));
    },
    /* Returns 'ew' (England & Wales), 'ni', 'scotland', 'islands' or null when invalid */
    region: function (value) {
      var formatted = this.format(value);
      var match = formatted.match(POSTCODE_RE);
      if (!match) return null;
      var outward = match[1];
      var area = outward.match(/^[A-Z]+/)[0];
      var district = parseInt(outward.replace(/^[A-Z]+/, ''), 10);
      if (area === 'BT') return 'ni';
      if (ISLANDS.indexOf(area) > -1) return 'islands';
      if (area === 'TR' && district >= 21 && district <= 25) return 'islands';
      if (area === 'TD' && (district === 12 || district === 15)) return 'ew';
      if (SCOTLAND.indexOf(area) > -1) return 'scotland';
      return 'ew';
    }
  };

  /* Checks a pair of postcodes against a service ('ew' or 'ni').
     Returns { ok: bool, kind: 'ni'|'ew'|'scotland'|'islands'|'invalid'|null } */
  CCC.checkRoute = function (from, to, service) {
    var a = from ? CCC.postcode.region(from) : undefined;
    var b = to ? CCC.postcode.region(to) : undefined;
    if ((from && a === null) || (to && b === null)) return { ok: false, kind: 'invalid' };
    var regions = [a, b].filter(Boolean);
    if (regions.indexOf('islands') > -1) return { ok: false, kind: 'islands' };
    if (settings.blockScotland && regions.indexOf('scotland') > -1) return { ok: false, kind: 'scotland' };
    var hasNI = regions.indexOf('ni') > -1;
    if (service === 'ni') {
      if (regions.length === 2 && !hasNI) return { ok: false, kind: 'ew' };
      return { ok: true, kind: null };
    }
    if (hasNI) return { ok: false, kind: 'ni' };
    return { ok: true, kind: null };
  };

  CCC.routeMessage = function (kind) {
    switch (kind) {
      case 'scotland': return settings.scotlandMessage || "We don't cover Scotland yet.";
      case 'islands': return settings.islandsMessage || "We can't book island addresses online.";
      case 'invalid': return 'Check the postcode. It should look like B13 9PB.';
      default: return '';
    }
  };

  /* ---------- Cart count ---------- */
  CCC.updateCartCount = function (count) {
    function apply(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
      document.querySelectorAll('[data-cart-link]').forEach(function (el) {
        el.classList.toggle('is-empty', n === 0);
      });
    }
    if (typeof count === 'number') return apply(count);
    return fetch((CCC.routes && CCC.routes.cartJs) || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { apply(cart.item_count); })
      .catch(function () {});
  };

  /* ---------- Analytics helper ---------- */
  CCC.track = function (name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* ignore */ }
  };

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var drawer = header.querySelector('[data-menu-drawer]');
    var openBtn = header.querySelector('[data-menu-open]');
    if (drawer && openBtn && typeof drawer.showModal === 'function') {
      openBtn.addEventListener('click', function () {
        drawer.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
      var close = function () { drawer.close(); };
      drawer.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
      drawer.addEventListener('close', function () {
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        openBtn.focus();
      });
    }

    var dropdowns = header.querySelectorAll('[data-nav-dropdown]');
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dropdowns.forEach(function (d) { d.open = false; });
    });
  }

  /* ---------- Announcement rotation (phones) ---------- */
  function initAnnouncements() {
    document.querySelectorAll('[data-announce]').forEach(function (bar) {
      var items = bar.querySelectorAll('.announce__item');
      if (items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var index = 0;
      var timer = null;
      var mq = window.matchMedia('(min-width: 990px)');
      function tick() {
        if (mq.matches) return;
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }
      function start() { if (!timer) timer = setInterval(tick, 4000); }
      function stop() { clearInterval(timer); timer = null; }
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      start();
    });
  }

  /* ---------- Quote slip (hero) ---------- */
  function initQuote(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';

    var from = form.querySelector('[name="from"]');
    var to = form.querySelector('[name="to"]');
    var bike = form.querySelector('[data-quote-bike]');
    var price = form.querySelector('[data-quote-price]');
    var note = form.querySelector('[data-quote-note]');
    var notice = form.querySelector('[data-quote-notice]');
    var submit = form.querySelector('[type="submit"]');
    var bookingUrl = form.dataset.bookingUrl;
    var niUrl = form.dataset.niUrl;
    var niFrom = form.dataset.niFrom;
    var defaultNote = note ? note.textContent : '';
    var defaultPrice = price ? price.innerHTML : '';
    var route = { ok: true, kind: null };

    function selectedOption() {
      return bike && bike.selectedIndex > -1 ? bike.options[bike.selectedIndex] : null;
    }

    function setNotice(html, tone) {
      if (!notice) return;
      if (!html) { notice.hidden = true; notice.innerHTML = ''; return; }
      notice.className = 'notice slip__notice' + (tone ? ' notice--' + tone : '');
      notice.innerHTML = html;
      notice.hidden = false;
    }

    function update() {
      var opt = selectedOption();
      route = CCC.checkRoute(from && from.value.trim(), to && to.value.trim(), 'ew');

      if (route.kind === 'ni' && niUrl) {
        if (price) price.innerHTML = '<small>Northern Ireland service</small>From ' + niFrom;
        if (note) note.textContent = 'Journeys to or from Northern Ireland have their own rates.';
        setNotice('');
      } else {
        if (price) {
          if (opt && opt.value) {
            price.innerHTML = '<small>' + escapeHtml(opt.textContent.split(' – ')[0]) + '</small>' + opt.dataset.price;
          } else {
            price.innerHTML = defaultPrice;
          }
        }
        if (note) note.textContent = defaultNote;
        if (!route.ok && route.kind !== 'ni') {
          var msg = CCC.routeMessage(route.kind);
          if (route.kind === 'scotland' || route.kind === 'islands') {
            msg += settings.whatsapp ? ' <a href="' + settings.whatsapp + '" target="_blank" rel="noopener">WhatsApp us</a>' : '';
          }
          setNotice('<svg class="icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4.2l8.8 15.3H3.2z"/><path d="M12 10v4.2M12 16.8v.4"/></svg><span>' + msg + '</span>', 'warn');
        } else {
          setNotice('');
        }
      }
      if (submit) submit.setAttribute('aria-disabled', !route.ok && route.kind !== 'ni' ? 'true' : 'false');
    }

    function tidy(input) {
      if (!input || !input.value.trim()) return;
      input.value = CCC.postcode.format(input.value);
    }

    [from, to].forEach(function (input) {
      if (!input) return;
      input.addEventListener('blur', function () { tidy(input); update(); });
      input.addEventListener('input', function () {
        if (CCC.postcode.isValid(input.value) || !input.value.trim()) update();
      });
    });
    if (bike) bike.addEventListener('change', update);

    form.addEventListener('submit', function (e) {
      tidy(from); tidy(to);
      update();
      if (!route.ok && route.kind !== 'ni') {
        e.preventDefault();
        if (notice) notice.focus && notice.focus();
        return;
      }
      e.preventDefault();
      var opt = selectedOption();
      var params = new URLSearchParams();
      var target = bookingUrl;
      if (route.kind === 'ni' && niUrl) {
        target = niUrl;
        if (opt && opt.value) params.set('bike', opt.dataset.title || '');
      } else if (opt && opt.value) {
        params.set('variant', opt.value);
      }
      if (from && from.value.trim()) params.set('from', CCC.postcode.format(from.value));
      if (to && to.value.trim()) params.set('to', CCC.postcode.format(to.value));
      CCC.track('ccc:quote_submitted', { bike: opt ? opt.dataset.title : '', region: route.kind || 'ew' });
      var qs = params.toString();
      window.location.href = target + (qs ? (target.indexOf('?') > -1 ? '&' : '?') + qs : '');
    });

    update();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  CCC.escapeHtml = escapeHtml;

  /* ---------- Cart page quantity buttons ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.qtyStep, 10);
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          input.value = next;
          if (input.form) input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
        });
      });
    });
  }


  /* ---------- Van mascot ---------- */
  function initVanMascot() {
    var root = document.querySelector('[data-van-mascot]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    var store = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
                  set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } } };
    if (store.get('ccc-van-hidden') === '1') return;

    var rider = root.querySelector('[data-van-rider]');
    var bubble = root.querySelector('[data-van-bubble]');
    var closeBtn = root.querySelector('[data-van-close]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idleTimer = null, bubbleTimer = null, lastY = window.scrollY, ticking = false;

    root.hidden = false;

    function progress() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      return max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    }
    function place() {
      var track = root.clientWidth - rider.offsetWidth;
      rider.style.transform = 'translateX(' + Math.round(track * progress()) + 'px)';
      ticking = false;
    }
    function showBubble(ms) {
      root.classList.add('is-talking');
      clearTimeout(bubbleTimer);
      bubbleTimer = setTimeout(function () { root.classList.remove('is-talking'); }, ms || 3500);
    }

    if (reduce) {
      root.classList.add('is-still');
      return;
    }

    /* Drive in from the left edge on each page, then follow the scroll */
    rider.style.transform = 'translateX(-130%)';
    requestAnimationFrame(function () {
      root.classList.add('is-moving');
      requestAnimationFrame(function () {
        place();
        setTimeout(function () {
          root.classList.remove('is-moving');
          root.classList.add('is-waving');
          if (store.get('ccc-van-greeted') !== '1') { store.set('ccc-van-greeted', '1'); showBubble(4500); }
          setTimeout(function () { root.classList.remove('is-waving'); }, 2400);
        }, 900);
      });
    });

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      root.classList.toggle('is-reversing', y < lastY);
      lastY = y;
      root.classList.add('is-moving');
      root.classList.remove('is-waving');
      if (!ticking) { ticking = true; requestAnimationFrame(place); }
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        root.classList.remove('is-moving');
        root.classList.add('is-waving');
        setTimeout(function () { root.classList.remove('is-waving'); }, 2400);
      }, 700);
    }, { passive: true });
    window.addEventListener('resize', function () { requestAnimationFrame(place); });

    rider.addEventListener('mouseenter', function () { showBubble(3000); root.classList.add('is-waving'); });
    rider.addEventListener('mouseleave', function () { root.classList.remove('is-waving'); });
    rider.addEventListener('focusin', function () { showBubble(4000); });

    if (closeBtn) closeBtn.addEventListener('click', function () {
      store.set('ccc-van-hidden', '1');
      root.classList.add('is-leaving');
      setTimeout(function () { root.hidden = true; }, 600);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-quote]').forEach(initQuote);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAnnouncements();
    initQty();
    initVanMascot();
    init();
  });

  /* Theme editor: re-run when sections change */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initAnnouncements(); });
})();
